import { useState } from 'react'
import { Icon, Tabs, Typography, type ITabItem } from 'shared/ui'
import type { IIconsVector } from 'shared/ui/Icon/icons'
import type { MergeField as MergeFieldModel } from 'entities/MergeField/model/MergeField'
import type { IAgentActionKey } from 'entities/AIAgent/lib/agentActions'
import { MergeField, type IMergeFieldConfig } from 'widgets/MergeField'
import styles from './styles.module.scss'

type IShortcutMenuTab = 'mergeFields' | 'actions'

type IActionItem = {
  key: IAgentActionKey
  icon: IIconsVector
  label: string
}

const tabs: ITabItem<IShortcutMenuTab>[] = [
  { key: 'mergeFields', name: 'Merge fields' },
  { key: 'actions', name: 'Actions' },
]

const actionItems: IActionItem[] = [
  { key: 'addTag', icon: 'tag', label: 'Add tag' },
  { key: 'removeTag', icon: 'tagRemove', label: 'Remove tag' },
  { key: 'addNote', icon: 'edit', label: 'Add contact note' },
  { key: 'sendSMS', icon: 'messageTextCircle02', label: 'Send SMS' },
  { key: 'stopConversation', icon: 'stop', label: 'Stop agent' },
]

type IShortcutMenuProps = {
  onClose: () => void
  mergeFieldConfig: IMergeFieldConfig
  onAddMergeField: (field: MergeFieldModel, replaceContent?: string) => void
  onActionItemClick: (key: IAgentActionKey, onClose: () => void) => void
}

export const ShortcutMenu = ({
  onClose,
  mergeFieldConfig,
  onAddMergeField,
  onActionItemClick,
}: IShortcutMenuProps) => {
  const [activeTab, setActiveTab] = useState<IShortcutMenuTab>('mergeFields')

  return (
    <div className={styles.wrap}>
      <Tabs
        tabs={tabs}
        activeTabKey={activeTab}
        handleSelectTab={(tab) => setActiveTab(tab.key)}
        variant={'default'}
        tabsClassName={styles.tabs}
      />
      {activeTab === 'mergeFields' && (
        <MergeField
          onCloseMenu={onClose}
          isNoAutoFocus
          onAddMergeField={(field) => onAddMergeField(field, '/')}
          {...mergeFieldConfig}
        />
      )}
      {activeTab === 'actions' && (
        <div className={styles.actionList}>
          {actionItems.map((item) => (
            <div
              key={item.key}
              className={styles.actionItem}
              onClick={() => onActionItemClick(item.key, onClose)}
            >
              <Icon icon={item.icon} className={styles.actionIcon} />
              <Typography variant={'body-md-regular'} ariaLabel={item.label}>
                {item.label}
              </Typography>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
